import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const PlayerViewport = memo(({ inputRef, id }) => <div ref={inputRef} id={id} />);

PlayerViewport.propTypes = {
  inputRef: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
